module.exports = __webpack_public_path__ + "media/promo/courses/images/f1-11db7262e7fcda1408f4ecd93ea687db.svg";